<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1000px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text px-10"
        v-on="on"
      >
        Create Company
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Company"
      text="Create Company"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="!loading">
        <v-container>
          <v-row>
            <v-col cols="4">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                outlined
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                data-vv-as="company name"                
                label="Company Name"
              />
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-model="registrationNo"
                v-validate="'required'"
                outlined
                :error-messages="errors.collect('registrationNo')"
                data-vv-name="registrationNo"                
                data-vv-as="registration no"                
                label="Registration No"
              />
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-model="addressLine1"
                v-validate="'required'"
                :error-messages="errors.collect('addressLine1')"
                data-vv-name="addressLine1"
                data-vv-as="address line 1"
                label="Address Line 1"
                outlined
              />
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-model="employerEpfNumber"
                v-validate="'required'"
                :error-messages="errors.collect('employerEpfNumber')"
                data-vv-name="employerEpfNumber"                
                data-vv-as="employer EPF no"                
                label="Employer EPF No"
                outlined
              />
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-model="employerEisNumber"
                v-validate="'required'"
                :error-messages="errors.collect('employerEisNumber')"
                data-vv-name="employerEisNumber"                
                data-vv-as="employer EIS no"                
                label="Employer EIS No"
                outlined
              />
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-model="addressLine2"
                :disabled="!addressLine1"
                :filled="!addressLine1"
                label="Address Line 2"
                outlined
              />
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-model="employerSocsoNumber"
                v-validate="'required'"
                :error-messages="errors.collect('employerSocsoNumber')"
                data-vv-name="employerSocsoNumber"                
                data-vv-as="employer SOCSO no"                
                label="Employer SOCSO No"
                outlined
              />
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-model="employerIncomeTaxNumber"
                v-validate="'required|length:11|validAlphanumeric'"
                :error-messages="errors.collect('employerIncomeTaxNumber')"
                data-vv-name="employerIncomeTaxNumber"                
                data-vv-as="employer income tax no"                
                label="Employer income tax No"
                outlined
                @input="employerIncomeTaxNumber = employerIncomeTaxNumber.toUpperCase()"
              />
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-model="addressLine3"
                :disabled="!addressLine1"
                :filled="!addressLine1"
                label="Address Line 3"
                outlined
              />
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-model="personInCharge"
                v-validate="'required'"
                :error-messages="errors.collect('personInCharge')"
                data-vv-name="personInCharge"                
                data-vv-as="person in charge"                
                label="Person In Charge"
                outlined
              />
            </v-col>

            <v-col cols="4">
              <v-text-field  
                v-model="personInChargeIc"
                v-validate="'required|icDate|icLength'"
                v-mask="'######-##-####'"
                :error-messages="errors.collect('person_in_charge_ic')"
                data-vv-name="person_in_charge_ic"                
                data-vv-as="person in charge ic"    
                label="Person In Charge IC"    
                outlined
                @input="icValidation(personInChargeIc)"
              />
            </v-col>

            <v-col cols="4">
              <v-autocomplete
                v-model="postcode"
                v-validate="'required'"
                :items="postcodes"
                item-text="postcode"
                item-value="postcode"
                value="postcode"
                :error-messages="errors.collect('postcode')"
                data-vv-name="postcode"
                data-vv-as="postcode"
                label="Postcode"
                outlined
                @input="postCodeOnChanged(postcode)"
              />
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-model="personInChargePosition"
                v-validate="'required'"
                :error-messages="errors.collect('personInChargePosition')"
                data-vv-name="personInChargePosition"                
                data-vv-as="person in charge position"                
                label="Person In Charge Position"
                outlined
              />
            </v-col>            

            <!-- <v-col cols="4">
              <v-text-field
                v-model="payrollPersonInCharge"
                v-validate="'required'"
                :error-messages="errors.collect('payrollPersonInCharge')"
                data-vv-name="payrollPersonInCharge"                
                data-vv-as="payroll person in charge"                
                label="Payroll Person In Charge"
                outlined
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="payrollPersonInChargePosition"
                v-validate="'required'"
                :error-messages="errors.collect('payrollPersonInChargePosition')"
                data-vv-name="payrollPersonInChargePosition"                
                data-vv-as="payroll person in charge position"                
                label="Payroll Person In Charge Position"
                outlined
              />
            </v-col> -->
         
            <v-col cols="4">
              <v-text-field
                v-model="hrdfRate"
                label="HRDF Rate (%)"
                outlined
                type="number"
              />
            </v-col>

            <v-col cols="4">
              <v-autocomplete
                v-model="city"
                v-validate="'required'"
                :filled="!postcode"
                :items="filteredCities"
                :error-messages="errors.collect('city')"
                :disabled="dropdownDisabled"
                data-vv-name="city"
                data-vv-as="city"
                item-text="name"
                item-value="id"
                value="id"
                label="City"
                hide-selected
                outlined
                @input="cityOnChanged(city)"
              />
            </v-col>            

            <v-col cols="4">
              <v-text-field  
                v-model="phoneNumber"
                v-validate="'required|phoneLength'"
                v-mask="['###-########']"
                :error-messages="errors.collect('phoneNumber')"
                data-vv-name="phoneNumber"                
                data-vv-as="phoneNumber"    
                label="Company Phone Number"
                outlined
              />
            </v-col>

            <v-col cols="4">
              <v-text-field  
                v-model="email"
                v-validate="'email'"
                :error-messages="errors.collect('email')"
                data-vv-name="email"                
                data-vv-as="email"    
                label="Company Email"
                outlined
              />
            </v-col>

            <v-col cols="4">
              <v-autocomplete
                v-model="state"
                v-validate="'required'"
                :error-messages="errors.collect('state')"
                data-vv-name="state"
                data-vv-as="state"
                disabled
                :filled="!city"
                :items="states"
                item-text="name"
                item-value="id"
                value="id"
                label="State"
                hide-selected
                outlined
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions v-if="!loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"  
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary" 
          class="white--text px-10"        
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        name: null,
        registrationNo: null,
        employerEpfNumber: null,
        employerEisNumber: null,
        employerSocsoNumber: null,
        employerIncomeTaxNumber: null,
        personInCharge: null,
        personInChargeIc: null,
        personInChargePosition: null,
        // payrollPersonInCharge: null,
        // payrollPersonInChargePosition: null,
        address: null,
        phoneNumber: null,
        hrdfRate: 0,
        loading: false,

        postcodes: [],
        cities: [],
        states: [],
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        postcode: null,
        city: null,
        state: null,
        dropdownDisabled: null,
        cityIds: [],    
        email: null,    
      }
    },
    computed: {
      filteredCities () {
        return this.cities.filter(city => {
          return this.cityIds.includes(city.id)
        })         
      },   
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()

        this.loading = true

        Promise.all([
          this.$api.states().list(),
          this.$api.cities().list(),
          this.$api.postcodes().list(),
        ])
          .then(([states, cities, postcodes]) => {
            this.states = states.data
            this.cities = cities.data
            this.postcodes = _.orderBy(postcodes.data, ['postcode'], ['asc'])

            this.loading = false
          })
      },
    },
    created () {
      let scope = this

      this.$validator.extend('icDate', {
        getMessage (field, args) {
          return 'Invalid IC Date'        
        },
        validate (value, args) {
          return scope.isValidDate(value) 
        },
      })
      this.$validator.extend('icLength', {
        getMessage (field, args) {
          return 'IC not in right length'        
        },
        validate (value, args) {
          return value.toString().length === 12
        },
      })
      this.$validator.extend('validAlphanumeric', {
        getMessage (field, args) {
          return 'Employer income tax number should not contain any special character'     
        },
        validate (value, args) {
          const regex = /^[A-Z0-9]*$/
          return regex.test(value)
        },
      })         
      this.$validator.extend('phoneLength', {
        getMessage (field, args) {
          return 'Invalid phone number (at least 9 numbers and max 11)'
        },
        validate (value, args) {
          return value.toString().length >= 10 && value.toString().length <= 12
        },
      })
    },    
    methods: { 
      isValidDate (value) {
        var y = parseInt(value.substr(0, 2))
        var m = parseInt(value.substr(2, 2))
        var d = parseInt(value.substr(4, 2))
        if (m === 0 || m > 12) { return false }
        var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ]
        // Adjust for leap years
        if (y % 400 === 0 || (y % 100 !== 0 && y % 4 === 0)) { monthLength[1] = 29 }
        return d > 0 && d <= monthLength[m - 1]
      },      
      icValidation (value) {
        if (value.toString().length === 14) {
          this.personInChargeIc = this.personInChargeIc.replace(/-/g, '')
          this.$validator.validate('person_in_charge_ic', this.personInChargeIc)
        }
      },      
      prepareFormData () {
        return {
          name: this.name,
          registration_no: this.registrationNo,
          employer_epf_number: this.employerEpfNumber,
          employer_eis_number: this.employerEisNumber,
          employer_socso_number: this.employerSocsoNumber,
          employer_income_tax_number: this.employerIncomeTaxNumber,
          person_in_charge: this.personInCharge,
          person_in_charge_ic: this.personInChargeIc,
          person_in_charge_position: this.personInChargePosition,
          phone_number: this.phoneNumber,
          hrdf_rate: this.hrdfRate * 100,
          address_line_one: this.addressLine1,
          address_line_two: this.addressLine2,
          address_line_three: this.addressLine3,
          postcode: this.postcode,
          city_id: this.city,
          state_id: this.state,
          email: this.email,
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
    
            this.$api.hrisCompanies().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 200 || res.status === 201) {
                  this.$emit('created', res.data)                
                  this.$snack({ message: 'Added new company' })

                  this.dialog = false               
                }
              })
              .catch((err) => {
                if (err.response.status === 500) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                }            
            
                this.progressing = false
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
      postCodeOnChanged (postcodeValue) {
        this.city = null
        this.state = null
        var cityID = this.postcodes.filter(p => {
          return p.postcode === postcodeValue
        })  

        this.cityIds = this.cities.filter(city => {
          return cityID.some(city2 => {
            return city2.city_id === city.id
          })
        }).map(city3 => {
          return city3.id
        })

        if (this.cityIds.length > 1) {
          this.dropdownDisabled = false
        } else {
          this.dropdownDisabled = true

          let cityId = (this.postcodes.find(postcode => {
            return postcode.postcode === postcodeValue
          }) || {}).city_id

          if (cityId) {
            var cityObject = this.getCity(cityId)
            if (cityObject) {
              this.city = cityObject.id
              var stateObject = this.getState(cityObject.state_id)
              
              if (stateObject) {
                this.state = stateObject.id
              }
            }
          }
        }
      },
      cityOnChanged (cityId) {
        var cityObject = this.getCity(cityId)
        if (cityObject) {
          var stateObject = this.getState(cityObject.state_id)
          
          if (stateObject) {
            this.state = stateObject.id
          }
        }
      },
      getCity (cityId) {
        if (isNaN(parseInt(cityId))) return null
        return this.cities.find(city => {
          return city.id === parseInt(cityId)
        })
      },
      getState (stateId) {
        if (isNaN(parseInt(stateId))) return null
        return this.states.find(state => {
          return state.id === parseInt(stateId)
        })
      },
  
    },
  }
</script>
